import { Card, CardBody, Col } from "reactstrap";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import { autoPlayData, autoPlayDataList } from "../../../../Data/BonusUi/Carousel";
import { dynamicImage } from "../../../../Utils";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import { AutoPlayVariants } from "../../../../Utils/Constants";

const AutoPlayVariant = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CardHeaderCommon title={AutoPlayVariants} span={autoPlayData} />
        <CardBody>
          <Swiper slidesPerView={1} autoplay={{ delay: 2500, disableOnInteraction: false }} pagination={{ clickable: true }} modules={[Autoplay, Pagination]} className="mySwiper swiper-h">
            {autoPlayDataList.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(item.image)} className="d-block w-100" alt="Vertical_Slider" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AutoPlayVariant;
